import React from 'react';
import { Box, ButtonBase, Typography, useTheme } from '@mui/material';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';

interface Props {
  label: string;
  caption?: string;
  count?: number;
  leading?: React.ReactNode;
  imageUrl?: string | null;
  selected?: boolean;
  folder?: boolean;
  onClick: () => void;
}

export default function DirectoryRow({
  label,
  caption,
  count,
  leading,
  imageUrl,
  selected,
  folder,
  onClick,
}: Props) {
  const theme = useTheme();
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        gap: 1.25,
        px: 1.25,
        py: 1,
        borderRadius: '10px',
        textAlign: 'left',
        fontFamily: theme.typography.fontFamily,
        bgcolor: selected ? 'accent.main' : 'transparent',
        '&:hover': { bgcolor: 'accent.main' },
      }}>
      {(leading || imageUrl) && (
        <Box
          sx={{
            width: 32,
            height: 32,
            borderRadius: '8px',
            bgcolor: 'lightGrey.main',
            overflow: 'hidden',
            flexShrink: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'text.secondary',
          }}>
          {imageUrl ? (
            <Box
              component="img"
              src={imageUrl}
              alt={label}
              sx={{ width: '100%', height: '100%', objectFit: 'cover' }}
            />
          ) : (
            leading
          )}
        </Box>
      )}
      <Box minWidth={0} flexGrow={1}>
        <Typography variant="subtitle2" noWrap>
          {label}
        </Typography>
        {caption && (
          <Typography
            variant="caption"
            color="text.secondary"
            noWrap
            display="block">
            {caption}
          </Typography>
        )}
      </Box>
      {count !== undefined && (
        <Typography variant="body2" color="text.secondary" flexShrink={0}>
          {count}
        </Typography>
      )}
      {folder && (
        <ChevronRightRoundedIcon
          fontSize="small"
          sx={{ color: 'text.disabled' }}
        />
      )}
      {selected && !folder && (
        <CheckRoundedIcon fontSize="small" sx={{ color: 'primary.main' }} />
      )}
    </ButtonBase>
  );
}
